module.exports = {
  messages: {
    BUTTON_SHOW_MORE: 'Show more',
    'JOBS_DATE_DAYS_LEFT_LABEL.one': '{variable_1} day left',
    'JOBS_DATE_DAYS_LEFT_LABEL.other': '{variable_1} days left',
    JOBS_DATE_EXPIRING_TODAY_LABEL: 'Expiring today',
    JOBS_HIGHLIGHT_URGENTLY_NEEDED: 'Urgently hiring',
    JOBS_JOB_TEASER_EXTERNAL_JOB_HIGHLIGHT: 'External job ad',
    JOBS_JOB_TEASER_EXTERNAL_JOB_HIGHLIGHT_A11Y:
      'External job ad. Posted by a partner',
    JOBS_JOB_TEASER_LINK_EXTERNAL_NEW_TAB_A11Y:
      'Click to open the external job ad in a new tab',
    JOBS_JOB_TEASER_LINK_NEW_TAB_A11Y:
      'Click to open the full job ad in a new tab',
    JOBS_KUNUNU_RATING_A11Y:
      'The employer rating on kununu is {value} out of 5 stars',
    JOBS_POSTING_GONE_SOON_MARKER: 'Gone soon',
    JOBS_POSTING_LAST_CHANCE_MARKER: 'Last chance',
    JOBS_SALARY_XING_ESTIMATED: '(XING estimate)',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: '30+ days ago',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO_A11Y: 'Posted more than 30 days ago',
    JOBS_TIMESTAMP_JUST_NOW: 'Just now',
    JOBS_TIMESTAMP_JUST_NOW_A11Y: 'Posted just now',
    JOBS_TIMESTAMP_N_DAYS_AGO: '{number} days ago',
    JOBS_TIMESTAMP_N_DAYS_AGO_A11Y: 'Posted {number} days ago',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {1 hour ago} other {# hours ago}}',
    JOBS_TIMESTAMP_N_HOURS_AGO_A11Y:
      '{number, plural, =1 {Posted 1 hour ago} other {Posted # hours ago}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Yesterday',
    JOBS_TIMESTAMP_YESTERDAY_A11Y: 'Posted yesterday',
  },
};
